module.exports = __webpack_public_path__ + "static/loyaltyCardBack-535e96fc5e4f22d4a6e4f342e06e3487.jpg";